import { Navigate, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboard/profile')({
  head: () => ({
    meta: [{ name: 'robots', content: 'noindex, nofollow' }],
  }),
  component: ProfileRedirectPage,
})

function ProfileRedirectPage() {
  return <Navigate to="/dashboard/settings" replace />
}
